// src/pages/FehlerGrenze.jsx
// --- FEHLERGRENZE ------------------------------------------------------------
// Ohne diese Grenze macht ein einziger Fehler beim Zeichnen einer Seite die
// GANZE App weiss - und nur Schliessen und neu Oeffnen hilft. Genau das haben
// die Monteure im Feldtest drei- bis fuenfmal erlebt.
//
// Jetzt: eine ruhige Meldung statt weissem Bildschirm, der Fehler geht
// automatisch ins Fehlerprotokoll, und es gibt zwei klare Auswege.
//
// Muss eine Klassen-Komponente sein - React faengt Anzeigefehler nur dort.
import React from 'react';
import { C } from './formui';
import { t } from '../lib/sprache';
import { fehlerMelden, istChunkFehler, nachUpdateNeuLaden } from '../lib/fehlerprotokoll';

const SCHRIFT = "system-ui,-apple-system,'Segoe UI',Roboto,'Helvetica Neue',Arial,sans-serif";

export default class FehlerGrenze extends React.Component {
  constructor(props) {
    super(props);
    this.state = { fehler: null, laedt: false };
    this.zurueck = this.zurueck.bind(this);
    this.neuLaden = this.neuLaden.bind(this);
  }

  static getDerivedStateFromError(fehler) {
    return { fehler: fehler || new Error(t('Unbekannter Fehler')) };
  }

  componentDidCatch(fehler, info) {
    try {
      fehlerMelden(fehler, { art: 'anzeige', stack: info && info.componentStack });
      // Veraltete Programmdatei nach einem Update (z. B. PDF-Baustein):
      // Neu laden hilft sofort - hoechstens einmal pro Minute.
      if (istChunkFehler(fehler)) nachUpdateNeuLaden();
    } catch { /* nie werfen */ }
  }

  componentDidUpdate(prevProps) {
    // Seite gewechselt -> neuer Versuch mit der neuen Seite.
    if (this.state.fehler && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ fehler: null });
    }
  }

  zurueck() {
    try { this.props.onZurueck?.(); } catch { /* nie werfen */ }
    this.setState({ fehler: null });
  }

  neuLaden() {
    if (this.state.laedt) return;
    this.setState({ laedt: true });
    try { window.dispatchEvent(new CustomEvent('etb-jetzt-speichern')); } catch { /* egal */ }
    setTimeout(() => { window.location.reload(); }, 400);
  }

  render() {
    const { fehler, laedt } = this.state;
    if (!fehler) return this.props.children;

    let kurz = '';
    try { kurz = String(fehler.message || fehler).slice(0, 200); } catch { kurz = ''; }

    const knopf = {
      width: '100%', minHeight: 52, padding: '12px 18px', borderRadius: 10,
      fontSize: 17, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit',
    };

    return (
      <div style={{ minHeight: '100vh', background: C.bg, display: 'flex', alignItems: 'center',
                    justifyContent: 'center', padding: 20, boxSizing: 'border-box', fontFamily: SCHRIFT }}>
        <div style={{ width: '100%', maxWidth: 440, background: C.white, borderRadius: 14,
                      padding: '28px 24px', boxShadow: '0 4px 24px rgba(10,22,40,0.12)' }}>
          <div style={{ fontWeight: 800, fontSize: 21, color: C.navy, marginBottom: 12 }}>
            {t('Da ist etwas hängen geblieben')}
          </div>
          <div style={{ fontSize: 16, color: C.gray700, lineHeight: 1.5, marginBottom: 22 }}>
            {t('Deine Eingaben sind auf dem Gerät gespeichert und gehen nicht verloren.')}
            {' '}{t('Der Fehler wurde automatisch an das Büro gemeldet.')}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <button type="button" onClick={this.zurueck} disabled={laedt}
              style={{ ...knopf, border: 'none', background: C.green, color: C.white }}>
              {t('Zurück zur Startseite')}
            </button>
            <button type="button" onClick={this.neuLaden} disabled={laedt}
              style={{ ...knopf, border: '1.5px solid ' + C.gray200, background: C.white, color: C.navy,
                       opacity: laedt ? 0.6 : 1 }}>
              {laedt ? t('speichert …') : t('App neu laden')}
            </button>
          </div>
          {kurz && (
            <div style={{ marginTop: 18, fontSize: 12, color: C.gray500, wordBreak: 'break-word' }}>
              {kurz}
            </div>
          )}
        </div>
      </div>
    );
  }
}
